/** Primary dictionary label for search / trending display. */
export function entrySearchLabel (entry) {
  if (!entry) return ''
  if (entry.term) return entry.term
  const parts = []
  if (entry.singular_masculine) parts.push(entry.singular_masculine)
  if (entry.singular_feminine) parts.push(entry.singular_feminine)
  if (parts.length) return parts.join(' · ')
  if (entry.plural_masculine) return entry.plural_masculine
  if (entry.plural_feminine) return entry.plural_feminine
  if (entry.singular_gender_neutral) return entry.singular_gender_neutral
  return ''
}

/** Search term for trending (masculine singular / term). */
export function entryTrendingSearchTerm (entry) {
  if (!entry) return ''
  if (entry.term) return entry.term
  if (entry.singular_masculine) return entry.singular_masculine
  if (entry.plural_masculine) return entry.plural_masculine
  if (entry.singular_feminine) return entry.singular_feminine
  if (entry.plural_feminine) return entry.plural_feminine
  if (entry.singular_gender_neutral) return entry.singular_gender_neutral
  return ''
}

/** Gender-neutral alternative for trending / compact display. */
export function entryNeutralLabel (entry) {
  if (!entry) return ''
  return (entry.singular_gender_neutral || entry.alternative || '').trim()
}

/** Trending list: only neutral dictionary entries with a usable alternative. */
export function entryIsTrendingNeutral (entry) {
  if (!entry) return false
  if (entry.type === 'star' || entry.type === 'pair') return false
  if (entry.type && entry.type !== 'neut') return false
  return !!entryNeutralLabel(entry)
}
